var ExportHeaders = /** @class */ (function () {
    function ExportHeaders() {
    }
    return ExportHeaders;
}());
export { ExportHeaders };
